@if (!isTouchDevice) {
  <content-scroll
    [parentName]="laneName"
    [isDisplayHorizontalScroll]="isDisplayHorizontalScroll"
    [gridScroll]="true"
    [gridScrollConfig]="controlStates"
    [adjustHeightForSingleTouchScroll]="adjustHeightForSingleTouchScroll"
    (changeGridHorizontalScroll)="scrollHorizontally($event)"
    (changeGridVerticalScroll)="scrollVertically($event)"
  >
    <ng-container *ngTemplateOutlet="grid"></ng-container>
  </content-scroll>
}

@if (isTouchDevice) {
  @if (controlStates.isTopFader) {
    <div class="top-fader"></div>
  }

  @if (controlStates.isLeftFader) {
    <div class="left-fader"></div>
  }

  <ng-container *ngTemplateOutlet="grid"></ng-container>

  @if (controlStates.isRightFader) {
    <div class="right-fader"></div>
  }

  @if (controlStates.isBottomFader) {
    <div class="bottom-fader"></div>
  }
}

<ng-template #grid>
  <ag-grid-angular
    focus-on-click
    [ngClass]="['ag-dm', _dmGridClass, 'e2e-attr-grid']"
    [rowData]="_rowData"
    [columnDefs]="_columnDefs"
    [rowBuffer]="rowBuffer"
    [cacheOverflowSize]="cacheOverflowSize"
    [maxBlocksInCache]="maxBlocksInCache"
    [gridOptions]="_gridOptions"
    [sortingOrder]="['asc', 'desc']"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
    (bodyScroll)="onBodyScroll($event)"
    (modelUpdated)="onModelUpdated($event)"
    (gridSizeChanged)="onGridSizeChanged($event)"
    [overlayNoRowsTemplate]="_noRowsTemplate | translate"
    (click)="onClick($event)"
    [components]="components"
  ></ag-grid-angular>
</ng-template>
